<template>
  <div class="banner">
    <div class="arrow-container">
      <!-- 左右箭头 - 轮播控制 -->
      <div class="arrow left nav-arrow" v-if="bannerList.length > 1" @click="prevImage" title="上一张广告">
        <img src="../../assets/images/arrow-banner.png" alt="左箭头">
      </div>
      <div class="arrow right nav-arrow" v-if="bannerList.length > 1" @click="nextImage" title="下一张广告">
        <img src="../../assets/images/arrow-banner.png" alt="右箭头">
      </div>

      <!-- 上下箭头 - 页面导航 -->
      <div class="arrow top scroll-arrow" @click="scrollToTop" title="回到顶部">
        <img src="../../assets/images/arrow-banner.png" alt="上箭头">
      </div>
      <div class="arrow bottom scroll-arrow" @click="scrollToNextModule" title="查看更多内容">
        <img src="../../assets/images/arrow-banner.png" alt="下箭头">
      </div>

      <!-- 斜向箭头 - 功能快捷键 -->
      <div class="arrow top-left function-arrow" @click="goToHome" title="返回首页">
        <img src="../../assets/images/arrow-banner.png" alt="左上箭头">
      </div>
      <div class="arrow top-right function-arrow" @click="openCustomerService" title="联系客服">
        <img src="../../assets/images/arrow-banner.png" alt="右上箭头">
      </div>
      <div class="arrow bottom-left function-arrow" @click="goToFeedback" title="反馈建议">
        <img src="../../assets/images/arrow-banner.png" alt="左下箭头">
      </div>
      <div class="arrow bottom-right function-arrow" @click="goToSpecial" title="专题页">
        <img src="../../assets/images/arrow-banner.png" alt="右下箭头">
      </div>
    </div>
    <!-- 大图 -->
    <div v-if="bannerList.length>0&&isBigorSmall=='大图'" class="banner-container">
      <v-carousel :sum="bannerList.length">
        <div v-for="(item, index) in bannerList" :key="index" class="box" @click="handleBig(item)">
          <img :src='picUrl + item.coverimg' alt class="bannerpic">
          <img src="../../assets/img/open_vio.png" alt="" class="videoIcon" v-if="item.type=='视频'">
          <div class="zhezhao" v-if="item.type=='视频'"></div>
          <span class="span1" v-if="item.titleshow==1&&item.titlepos=='左上角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span2" v-if="item.titleshow==1&&item.titlepos=='左下角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span3" v-if="item.titleshow==1&&item.titlepos=='顶部居中'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span4" v-if="item.titleshow==1&&item.titlepos=='底部居中'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span5" v-if="item.titleshow==1&&item.titlepos=='右上角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span6" v-if="item.titleshow==1&&item.titlepos=='右下角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span7" v-if="item.titleshow==1&&item.titlepos=='居中'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
        </div>
      </v-carousel>
    </div>
    <!--小图-->
    <div v-if="bannerList.length>0&&isBigorSmall=='小图'" class="banner-container">
      <div class="box1 slider">
        <div class="boList" v-for="(item, index) in bannerList" :key="index" @click="handleSmall(item)" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <img :src='picUrl + item.coverimg' alt class="bannerpic slider-item">
          <img src="../../assets/img/open_vio.png" alt="" class="videoIcon" v-if="item.type=='视频'">
          <div class="zhezhao" v-if="item.type=='视频'"></div>
          <span class="span1 ltt" v-if="item.titleshow==1&&item.titlepos=='左上角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span2 ltt" v-if="item.titleshow==1&&item.titlepos=='左下角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span3 ltt" v-if="item.titleshow==1&&item.titlepos=='顶部居中'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span4 ltt" v-if="item.titleshow==1&&item.titlepos=='底部居中'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span5 ltt" v-if="item.titleshow==1&&item.titlepos=='右上角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span6 ltt" v-if="item.titleshow==1&&item.titlepos=='右下角'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
          <span class="span7 ltt" v-if="item.titleshow==1&&item.titlepos=='居中'" :style="{'color':item.titlecolor,'fontFamily':item.titlefont}">{{item.title}}</span>
        </div>
      </div>
    </div>
    <!-- 视频播放对话框 -->
    <el-dialog :visible.sync="dialogVisible" width="50%">
      <video style="width: 100%;height: 400px;" v-if="dialogVisible" :src="videol" controls="controls">您的浏览器不支持 video 标签。</video>
    </el-dialog>
  </div>
</template>

<script>
import { getModuleAdvertising } from '@/axios/api'
import sign from '@/auth/sign'
import vCarousel from '@/components/common/Carousel'
import url from '@/axios/url'

export default {
  name: 'Banner',
  components: {
    vCarousel
  },
  data () {
    return {
      picUrl: url.picUrl,
      appid: 'wzwebapp',
      dialogVisible: false,
      isBigorSmall: '',
      bannerList: [],
      videol: '',
      currentIndex: 0,
      intervalId: null
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
    this.intervalId = null
  },
  created () {
    this.getIndexBanner()
    this.startAutoPlay()
  },
  methods: {
    prevImage () {
      this.currentIndex = (this.currentIndex - 1 + this.bannerList.length) % this.bannerList.length
    },
    nextImage () {
      this.currentIndex = (this.currentIndex + 1) % this.bannerList.length
      if (this.bannerList.length - this.currentIndex === 3) {
        this.currentIndex = 0
      }
    },
    startAutoPlay () {
      this.intervalId = setInterval(this.nextImage, 3000)
    },
    getIndexBanner () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        belong_id: 0
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      getModuleAdvertising(oneParams).then(res => {
        if (res.data.code === 200) {
          this.isBigorSmall = res.data.data.style
          this.bannerList = res.data.data.list
        }
      })
    },
    handleSmall (item) {
      if (item.type === '图片' && item.jumplinktype === 1) {
        window.open(item.jumplink, '_blank')
      }
      if (item.type === '视频' && item.videoways === 1) {
        this.dialogVisible = true
        this.videol = item.videourl
      }
      if (item.type === '视频' && item.videoways === 2) {
        window.open(item.jumplink, '_blank')
      }
    },
    handleBig (item) {
      if (item.type === '图片' && item.jumplinktype === 1) {
        window.open(item.jumplink, '_blank')
      }
      if (item.type === '视频' && item.videoways === 1) {
        this.dialogVisible = true
        this.videol = item.videourl
      }
      if (item.type === '视频' && item.videoways === 2) {
        window.open(item.jumplink, '_blank')
      }
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollToNextModule () {
      const banner = document.querySelector('.banner')
      const nextModule = banner.nextElementSibling
      if (nextModule) {
        nextModule.scrollIntoView({ behavior: 'smooth' })
      }
    },
    goToHome () {
      this.$router.push('/')
    },
    openCustomerService () {
      window.open('测试客服地址', '_blank')
    },
    goToFeedback () {
      this.$router.push('测试反馈页地址')
    },
    goToSpecial () {
      this.$router.push('自定义页面地址')
    }
  }
}
</script>

<style scoped lang="less">
.banner {
  width: 1200px;
  margin: 1px auto 0;
  position: relative;
}
.box {
  position: relative;
  width: 1200px;
  cursor: pointer;
}
.videoIcon {
  width: 48px;
  height: 42px;
  position: absolute;
  left: 42%;
  top: 30%
}
.zhezhao {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}
.bannerpic {
  width: 100%;
  height: 166px;
  object-fit: cover;
}
.span1 {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
  display: block;
  line-height: 26px;
  font-size: 24px;
  color: red;
}
.span2 {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 999;
  display: block;
  line-height: 26px;
  font-size: 24px;
  color: red;
}
.span3 {
  position: absolute;
  left: 40%;
  top: 0;
  z-index: 999;
  display: block;
  line-height: 26px;
  font-size: 24px;
  color: red;
}
.span4 {
  position: absolute;
  bottom: 0;
  z-index: 999;
  display: block;
  line-height: 26px;
  font-size: 24px;
  color: red;
}
.span5 {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
  display: block;
  line-height: 26px;
  font-size: 24px;
  color: red;
}
.span6 {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: block;
  line-height: 26px;
  font-size: 24px;
  color: red;
}
.span7 {
  position: absolute;
  left: 40%;
  bottom: 40%;
  z-index: 999;
  display: block;
  line-height: 26px;
  font-size: 24px;
  color: red;
}
.box1 {
  width: 1200px;
  height: 166px;
  overflow: hidden;
  display: -webkit-box;
  .boList {
    width: 24%;
    height: 100%;
    background: skyblue;
    position: relative;
    margin-right: 20px;
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .ltt {
      font-size: 16px;
    }
  }
}
.slider {
  overflow: hidden;
  width: 100%;
}
.slider-wrapper {
  display: flex;
  transition: transform 4s ease-in-out, opacity 0.5s linear;
}
.slider-item {
  min-width: 100%;
  flex-shrink: 0;
}

.banner-container {
  position: relative;
}

.arrow-container {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;
}

.arrow {
  position: absolute;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: auto;

  img {
    width: 24px;
    height: 24px;
    transition: transform 0.3s;
  }

  &:hover {
    opacity: 1;
    background: rgba(0, 0, 0, 0.9);
  }
}

// 左右导航箭头 - 始终显示
.nav-arrow {
  opacity: 0.6;
  top: 50%;
  transform: translateY(-50%);

  &.right img {
    transform: rotate(180deg);
  }
}

// 上下滚动箭头 - 悬停显示
.scroll-arrow {
  opacity: 0;

  &.top img {
    transform: rotate(90deg);
  }

  &.bottom img {
    transform: rotate(-90deg);
  }
}

// 功能箭头 - 悬停显示
.function-arrow {
  opacity: 0;

  &.top-left img {
    transform: rotate(45deg);
  }

  &.top-right img {
    transform: rotate(135deg);
  }

  &.bottom-left img {
    transform: rotate(-45deg);
  }

  &.bottom-right img {
    transform: rotate(-135deg);
  }
}

// 悬停时显示所有箭头
.banner:hover {
  .scroll-arrow,
  .function-arrow {
    opacity: 0.9;
  }
}

// 移动端隐藏斜向箭头
@media (max-width: 768px) {
  .function-arrow {
    display: none;
  }
}

.top-left {
  top: 20px;
  left: 20px;
}

.top {
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.top-right {
  top: 20px;
  right: 20px;
}

.left {
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
}

.right {
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.bottom-left {
  bottom: 20px;
  left: 20px;
}

.bottom {
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.bottom-right {
  bottom: 20px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Banner.vue